module.exports = __webpack_public_path__ + "d25ff31be0d7a264b585f00610786b09.png";